export default "__VITE_ASSET__284ba18b__"